<template>
<v-text-field hide-details="" :tabindex="tabdeger"  v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket" :name="name" @blur="isInputActive=false" :autocomplete="autocomplete"  @focus="isInputActive=true" >
</v-text-field>




</template>

<script>
export default {
  name: 'currency-input',
  data () {
    return {
      isInputActive: false
    }
  },
  props: ['value', 'tabdeger', 'name', 'id', 'autocomplete', 'etiket','aktif'],
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          return this.value.toString()
        } else {
          return this.value.toFixed(2)//.replace(/(\d)(?=(\d{4})+(?:\.\d+)?$)/g, '$1,')
        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue)
        if (isNaN(newValue)) {
          newValue = 0
        }
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped>
</style>
